import { Component, ViewChild } from '@angular/core';
import { Platform, Nav } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { Events } from 'ionic-angular';
import { HomePage } from '../pages/home/home';


import { Util } from './util';
@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = HomePage;
  pages = [];
  
  @ViewChild(Nav) nav: Nav;
  constructor(platform: Platform, statusBar: StatusBar, public events: Events) {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      //statusBar.styleDefault();
    });

    events.subscribe('categorieCaricate', (categorie) => {
      // user and time are the same arguments passed in `events.publish(user, time)`
      //console.log('id:', categoria.id, '--nome', categoria.nome);
      //console.log("CAT: ",categorie);
      this.pages = categorie;
    });
  }



  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    //this.getcategorie();
  }
  getcategorie() {
    //this.pages = [{ id: 1, nome: 'Categoria 1' }, { id: 2, nome: 'Categoria 2' }];
  }
  openPage(p) {

    //console.log("OPENPAGE");
    // if (this.nav.getActive() == null || this.nav.getActive().name != 'HomePage') {
    //   this.nav.setRoot(HomePage);
    // }

    //this.nav.setRoot(this.nav.getActive().component);
    this.events.publish('cambiocategoria', p);
  }
  openp(s) {

    this.events.publish('caricaHtml', s);
    
    
    
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts